import React, { FC, MouseEventHandler } from "react";
import { Button, SxProps, Theme, useTheme } from "@mui/material";

type ButtonSize = "small" | "medium";
type ButtonVariant = "contained" | "outlined";

interface CommonButtonProps {
  text?: string;
  size?: ButtonSize;
  variant?: ButtonVariant;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
  type?: "button" | "submit" | "reset";
}

const CommonButton: FC<CommonButtonProps> = ({
  text = "Button",
  onClick,
  disabled = false,
  fullWidth = false,
  size = "medium",
  variant = "contained",
  color,
  sx,
  type = "button",
  ...rest
}) => {
  const theme = useTheme();
  const isContained = variant === "contained";
  const hasColor = Boolean(color);

  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      disableElevation
      color={color}
      type={type}
      sx={{
        height: size === "small" ? 34 : 46,
        borderRadius: "8px",
        fontSize:{ xs: "12px", sm: "14px" , md: "16px"},
        fontWeight: size === "small" ? 500 : 600,
        textTransform: "none",
        ...(!hasColor &&
          (isContained
            ? {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.custom.white,

            }
            : {
              backgroundColor: theme.palette.custom.white,
              color: theme.palette.primary.main,
              border: `1px solid ${theme.palette.primary.main}`,

            })),
        ...sx,
      }}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default CommonButton;
